import { createReducer } from "@reduxjs/toolkit";
import {
  fetchDashboardUsers,
  fetchDashboardTasks,
  fetchDashboardFlows,
  fetchDashboardChat,
  setDashboardMarker,
  updateDashboardUser,
  removeDashboardUser,
  clearAllDashboardData,
} from "./actions";

const initialState = {
  usersProductivity: {
    data: [],
    status: "idle",
    error: null,
  },
  tasksProductivity: {
    data: [],
    status: "idle",
    error: null,
  },
  flowsProductivity: {
    data: [],
    status: "idle",
    error: null,
  },
  chatProductivity: {
    data: [],
    status: "idle",
    error: null,
  },
  // Add additional state slices as needed
};

const dashboardReducer = createReducer(initialState, (builder) => {
  builder

    .addCase(clearAllDashboardData, () => initialState)

    // Handle fetching Users Productivity for Dashboard
    .addCase(fetchDashboardUsers.pending, (state) => {
      state.usersProductivity.status = "loading";
    })
    .addCase(fetchDashboardUsers.fulfilled, (state, action) => {
      state.usersProductivity.status = "succeeded";
      state.usersProductivity.data = action.payload;
    })
    .addCase(fetchDashboardUsers.rejected, (state, action) => {
      state.usersProductivity.status = "failed";
      state.usersProductivity.error = action.payload;
    })

    // Handle fetching Tasks Productivity for Dashboard
    .addCase(fetchDashboardTasks.pending, (state) => {
      state.tasksProductivity.status = "loading";
    })
    .addCase(fetchDashboardTasks.fulfilled, (state, action) => {
      state.tasksProductivity.status = "succeeded";
      state.tasksProductivity.data = action.payload;
    })
    .addCase(fetchDashboardTasks.rejected, (state, action) => {
      state.tasksProductivity.status = "failed";
      state.tasksProductivity.error = action.payload;
    })

    // Handle fetching Flows Productivity for Dashboard
    .addCase(fetchDashboardFlows.pending, (state) => {
      state.flowsProductivity.status = "loading";
    })
    .addCase(fetchDashboardFlows.fulfilled, (state, action) => {
      state.flowsProductivity.status = "succeeded";
      state.flowsProductivity.data = action.payload;
    })
    .addCase(fetchDashboardFlows.rejected, (state, action) => {
      state.flowsProductivity.status = "failed";
      state.flowsProductivity.error = action.payload;
    })

    // Handle fetching Chat Modifications for Dashboard
    .addCase(fetchDashboardChat.pending, (state) => {
      state.chatProductivity.status = "loading";
    })
    .addCase(fetchDashboardChat.fulfilled, (state, action) => {
      state.chatProductivity.status = "succeeded";
      state.chatProductivity.data = action.payload;
    })
    .addCase(fetchDashboardChat.rejected, (state, action) => {
      state.chatProductivity.status = "failed";
      state.chatProductivity.error = action.payload;
    })

    // Handle setting a marker for the dashboard
    .addCase(setDashboardMarker, (state, action) => {
      // Implement logic to set the marker based on action payload
      // For example, if action.payload contains a specific module and a marker value
      state[action.payload.module].marker = action.payload.marker;
    })
    // Handle updates for a dashboard user
    .addCase(updateDashboardUser, (state, action) => {
      // Implement logic to update the user based on action payload
      const index = state.usersProductivity.data.findIndex(
        (user) => user.id === action.payload.id
      );
      if (index !== -1) {
        state.usersProductivity.data[index] = action.payload;
      }
    })
    // Handle removal of a dashboard user
    .addCase(removeDashboardUser, (state, action) => {
      // Implement logic to remove the user based on action payload
      state.usersProductivity.data = state.usersProductivity.data.filter(
        (user) => user.id !== action.payload.id
      );
    });
  // Additional handlers for other actions can be added here
});

export default dashboardReducer;
